<template>
  <n-config-provider :theme="darkTheme" :theme-overrides="themeOverrides">
    <n-message-provider>
      <AppLayout ref="layout">
        <router-view />
      </AppLayout>
    </n-message-provider>
  </n-config-provider>
</template>

<script setup>
import { ref, provide, onMounted } from 'vue';
import { darkTheme } from 'naive-ui';
import AppLayout from './components/AppLayout.vue';

const layout = ref(null);

onMounted(() => {
  provide('layout', layout);
});

// Align naive-ui with the Obsidian Ledger tokens.
const themeOverrides = {
  common: {
    bodyColor: '#131317',
    cardColor: '#1f1f23',
    modalColor: '#2a292e',
    popoverColor: '#2a292e',
    primaryColor: '#00e5ff',
    primaryColorHover: '#9cf0ff',
    primaryColorPressed: '#00daf3',
    primaryColorSuppl: '#00e5ff',
    infoColor: '#00e5ff',
    successColor: '#00e5ff',
    errorColor: '#ffb3ae',
    warningColor: '#ffb3ae',
    textColorBase: '#e4e1e7',
    textColor1: '#e4e1e7',
    textColor2: '#e4e1e7',
    textColor3: '#bac9cc',
    baseColor: '#131317',
    borderColor: 'rgba(59, 73, 76, 0.2)',
    dividerColor: 'rgba(59, 73, 76, 0.2)',
    borderRadius: '10px',
    borderRadiusSmall: '6px',
    fontFamily: '"Inter", system-ui, sans-serif',
    fontFamilyMono: '"JetBrains Mono", ui-monospace, monospace',
  },
  Card: {
    color: '#1f1f23',
    borderColor: 'transparent',
    titleFontWeight: 600,
  },
  Button: {
    textColorPrimary: '#00363d',
    colorPrimary: '#00e5ff',
    colorHoverPrimary: '#9cf0ff',
    colorPressedPrimary: '#00daf3',
    colorFocusPrimary: '#9cf0ff',
    fontWeight: '600',
  },
  Menu: {
    itemColorActive: 'rgba(0, 229, 255, 0.08)',
    itemTextColorActive: '#c3f5ff',
    itemIconColorActive: '#00e5ff',
  },
  Input: {
    color: '#1b1b1f',
    colorFocus: '#1f1f23',
    borderHover: '#00e5ff',
    borderFocus: '#00e5ff',
  },
  DataTable: {
    thColor: 'transparent',
    tdColor: 'transparent',
    tdColorHover: '#1b1b1f',
    thTextColor: '#bac9cc',
  },
};
</script>
